import { Col, Container } from 'react-bootstrap'
import { t } from '../locale'

interface Step {
    labelKey: string
    href?: string
}

interface VerificationStepNavProps {
    currentStep: number
    companyId: string
    requestId: string
    onBack?: () => void
    spaceHeight?: string
}

const STEPS: Step[] = [
    { labelKey: 'personalData' },
    { labelKey: 'documentVerification' },
    { labelKey: 'faceVerification' },
    { labelKey: 'videoVerification' },
    { labelKey: 'accountVerification' }
]

function stepImage(index: number, current: number): string {
    if (index < current) return `/images/logo/Step ${index + 1} Done.png`
    if (index === current) return `/images/logo/Step ${index + 1} Active.png`
    return `/images/logo/Step ${index + 1} Next.png`
}

function stepTextColor(index: number, current: number): string {
    if (index < current) return 'text-success'
    if (index === current) return 'text-primary'
    return 'text-gray-light'
}

export default function VerificationStepNav({
    currentStep,
    companyId,
    requestId,
    onBack,
    spaceHeight = ''
}: VerificationStepNavProps) {
    const step1Href = `/${companyId}/${requestId}/p`

    const mobileNav = (
        <Container className='container-fluid px-sm-5'>
            <Col className='col-12 px-0 bg-white d-flex d-sm-none sticky-top z-0'>
                <div className='d-flex flex-row flex-grow-1 align-items-between align-items-sm-start px-2 pe-3 pt-3'>
                    <ul className='nav nav-pills flex-row flex-nowrap flex-shrink-1 flex-grow-1 mb-0 justify-content-between align-items-center' id='menu'>
                        {STEPS.map((_, i) => (
                            <li key={i} className='nav-item'>
                                <a href={i === 0 ? step1Href : undefined} className='nav-link px-sm-0 px-2'>
                                    <img src={stepImage(i, currentStep - 1)} className='img-fluid step-numbers' alt='' />
                                </a>
                            </li>
                        ))}

                        {onBack && (
                            <li>
                                <button className='btn btn-success btn-lg text-white' onClick={onBack}>
                                    {t('back')}
                                </button>
                            </li>
                        )}
                    </ul>
                </div>
            </Col>
        </Container>
    )

    // Desktop Sidebar
    const desktopNav = (
        <Col className={`col-12 col-sm-3 col-xl-2 px-0 bg-white d-none d-sm-flex sticky-top pt-4 left-sidebar ${spaceHeight}`}>
            <div className='d-flex flex-sm-column flex-row flex-grow-q align-items-center align-items-sm-start px-0 pt-2 text-white'>
                <ul className='nav nav-pills flex-sm-column flex-row flex-nowrap flex-shrink-1 flex-sm-grow-0 flex-grow-1 mb-sm-auto mb-0
                                justify-content-center align-items-center align-items-sm-start' id='menu'>
                    {STEPS.map((step, i) => (
                        <li key={i} className='mb-4 nav-item'>
                            <a href={i === 0 ? step1Href : undefined} className='nav-link px-sm-0 px-2'>
                                <img src={stepImage(i, currentStep - 1)} className='img-fluid step-numbers' alt='' />
                                <span className={`ms-1 d-none d-sm-inline ${stepTextColor(i, currentStep - 1)}`}>
                                    {t(step.labelKey)}
                                </span>
                            </a>
                        </li>
                    ))}
                    {onBack && (
                        <li>
                            <button className='btn btn-success btn-lg text-white' onClick={onBack}>
                                {t('back')}
                            </button>
                        </li>
                    )}
                </ul>
            </div>
        </Col>
    )

    return { mobileNav, desktopNav}
}